/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>GET /api/v2/live2d/can_use</strong>
 * LIVE2Dモデルが使用可能かを確認するAPI
 */
export interface Live2dCanUseResponse {
  canUseLive2d: boolean;
}

function createBaseLive2dCanUseResponse(): Live2dCanUseResponse {
  return { canUseLive2d: false };
}

export const Live2dCanUseResponse = {
  encode(message: Live2dCanUseResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.canUseLive2d === true) {
      writer.uint32(8).bool(message.canUseLive2d);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Live2dCanUseResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLive2dCanUseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.canUseLive2d = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Live2dCanUseResponse {
    return { canUseLive2d: isSet(object.canUseLive2d) ? globalThis.Boolean(object.canUseLive2d) : false };
  },

  toJSON(message: Live2dCanUseResponse): unknown {
    const obj: any = {};
    if (message.canUseLive2d === true) {
      obj.canUseLive2d = message.canUseLive2d;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Live2dCanUseResponse>, I>>(base?: I): Live2dCanUseResponse {
    return Live2dCanUseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Live2dCanUseResponse>, I>>(object: I): Live2dCanUseResponse {
    const message = createBaseLive2dCanUseResponse();
    message.canUseLive2d = object.canUseLive2d ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
